import theme from '@/presentation/assets/styles/theme'

import { Box, useScrollTrigger } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Analytics } from '../analytics'
import DesktopHeader from './desktop/desktop-header'
import MobileHeader from './mobile/mobile-header'

type LoggedHeaderProps = {
  desktopNavMenu?: React.ReactElement
  targetScroll?: Node | null
  enableSearch?: boolean
}

export default function LoggedHeader({
  targetScroll,
  desktopNavMenu,
  enableSearch = false
}: LoggedHeaderProps) {
  const [trigger, setTrigger] = useState(false)
  const [target, setTarget] = useState(targetScroll)
  const [menuAnchorEl, setMenuAnchorEl] = useState<null | HTMLElement>(null)
  const [openDialogMenu, setOpenDialogMenu] = useState(false)
  const [openDialogSearchMenu, setOpenDialogSearchMenu] = useState(false)
  const menuOpen = Boolean(menuAnchorEl)

  const newTrigger = useScrollTrigger({
    target: target || undefined
  })

  useEffect(() => {
    setTarget(targetScroll)
  }, [targetScroll])

  if (newTrigger != trigger) {
    setTrigger(newTrigger)
  }

  const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
    Analytics.trackUserMenu(true)
    setOpenDialogMenu(true)
    setMenuAnchorEl(event.currentTarget)
  }

  const handleCloseMenu = () => {
    Analytics.trackUserMenu(false)
    setMenuAnchorEl(null)
    setOpenDialogMenu(false)
  }

  // Calculate header height for spacing
  // Desktop: 64px (main) + 64px (nav menu if exists)
  // Mobile: 64px (main only)
  const desktopHeaderHeight = desktopNavMenu ? theme.spacing(16) : theme.spacing(8)
  const mobileHeaderHeight = theme.spacing(8)

  return (
    <Box id="logged-header" component="header" className="w-screen relative z-[100]">
      {/* Desktop Header */}
      <DesktopHeader
        enableSearch={enableSearch}
        trigger={trigger}
        desktopNavMenu={desktopNavMenu}
        menuOpen={menuOpen}
        menuAnchorEl={menuAnchorEl}
        handleOpenMenu={handleOpenMenu}
        handleCloseMenu={handleCloseMenu}
      />

      {/* Mobile Header */}
      <MobileHeader
        enableSearch={enableSearch}
        trigger={trigger}
        openDialogMenu={openDialogMenu}
        openDialogSearchMenu={openDialogSearchMenu}
        setOpenDialogMenu={setOpenDialogMenu}
        setOpenDialogSearchMenu={setOpenDialogSearchMenu}
        handleOpenMenu={handleOpenMenu}
        handleCloseMenu={handleCloseMenu}
      />

      {/* Spacer to prevent content from going under fixed header */}
      <Box
        sx={{
          height: {
            xs: mobileHeaderHeight,
            md: desktopHeaderHeight
          }
        }}
      />
    </Box>
  )
}
